import {IOnlineCondolenceDetails} from '../../types/resources/OnlineCondolenceDetails';
import {useTranslation} from 'react-i18next';

type TProps = {
    details: IOnlineCondolenceDetails;
}

const FuneralDirectorInfo = ({details}: TProps) => {
    const {t} = useTranslation();

    return (
        <>
            <div className="cr-funeral-directory-title cr-bold cr-text-primary">{t('funeral-director')}</div>
            {details.assignedToDisplayName &&
                <div className={'cr-name'}>{details.assignedToDisplayName}</div>
            }
            {details.assignedToEmailAddress &&
                <a className={'cr-email'} href={`mailto:${details.assignedToEmailAddress}`}>{details.assignedToEmailAddress}</a>
            }
            {details.assignedToPhoneNumber &&
                <a className={'cr-phone'} href={`tel:${details.assignedToPhoneNumber}`}>{details.assignedToPhoneNumber}</a>
            }
        </>
    );
}

export default FuneralDirectorInfo;
